export default "__VITE_ASSET__BiqT9YPz__"